import axios from "axios";
import { ToastType } from "../../components/ToastManager/constants";
import { sendNotification } from "../../components/ToastManager/ToastManager";
import {
  profiles,
  studiesIds,
  unauthorizedStudyStatus,
} from "../../modules/constants";
import history from "../../modules/history";
import FAOD402DataComments from "../../pages/FAOD402/Admin/DataComments";
import AdminLanding from "../../pages/FAOD402/Admin/Landing";
import Management from "../../pages/BeyondXLH/Admin/Management";
import AnswerSurvey from "../../pages/FAOD402/Participant/AnswerSurvey";
import ParticipantLanding from "../../pages/FAOD402/Participant/Landing";
import ParticipantDietDiary from "../../pages/FAOD401/Participant/Landing";
import FAOD401Stats from "../../pages/FAOD401/Stats";
import FAOD401Favorites from "../../pages/FAOD401/Participant/Favorites";
import NextSteps from "../../pages/FAOD402/Participant/NextSteps";
import Charts from "../../pages/BeyondXLH/Charts";
import SurveyResults from "../../pages/FAOD402/Participant/Results";

const routesArray = [
  {
    path: "/study",
    genericRoute: true,
    authorize: [
      profiles.participant,
      profiles.medicalMonitor,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.studyAdmin,
    ],
    study: studiesIds.lcfaod402,
    redirectNonAuthorized: "/unauthorized",
  },
  {
    path: "/participant",
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod402,
    redirectNonStudyEnrolled: "/accessdenied",
    component: ParticipantLanding,
    authorize: [profiles.participant],
    study: studiesIds.lcfaod402,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/diet-diary",
    component: ParticipantDietDiary,
    authorize: [profiles.participant],
    study: studiesIds.lcfaod402,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/stats/:participantId?",
    component: FAOD401Stats,
    authorize: [
      profiles.participant,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.dietitian,
      profiles.medicalMonitor,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    redirectNonAuthorized: "/unauthorized",
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod402,
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
    study: studiesIds.lcfaod402,
  },
  {
    path: "/favorites",
    component: FAOD401Favorites,
    authorize: [profiles.participant],
    study: studiesIds.lcfaod402,
    redirectNonAuthorized: "/unauthorized",
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod402,
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/admin",
    component: AdminLanding,
    authorize: [
      profiles.medicalMonitor,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    redirectNonAuthorized: "/unauthorized",
    study: studiesIds.lcfaod402,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/participant/:participantId?",
    component: ParticipantLanding,
    authorize: [
      profiles.participant,
      profiles.medicalMonitor,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod402,
    redirectNonStudyEnrolled: "/accessdenied",
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
    study: studiesIds.lcfaod402,
  },
  {
    path: "/answer/:surveyDefinitionId?",
    component: AnswerSurvey,
    authorize: [profiles.participant],
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod402,
    redirectNonStudyEnrolled: "/accessdenied",
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: false,
  },
  {
    path: "/results/:surveyDefinitionId?/:participantId?",
    component: SurveyResults,
    authorize: [
      profiles.participant,
      profiles.medicalMonitor,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod402,
    redirectNonStudyEnrolled: "/accessdenied",
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
    study: studiesIds.lcfaod402,
  },
  {
    path: "/data-comments",
    component: FAOD402DataComments,
    authorize: [profiles.pi, profiles.medicalMonitor],
    study: studiesIds.lcfaod402,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/management",
    component: Management,
    authorize: [profiles.itAdmin],
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: false,
  },
  {
    path: "/next-steps",
    component: NextSteps,
    authorize: [profiles.participant],
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod402,
    redirectNonStudyEnrolled: "/accessdenied",
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: false,
  },

  {
    path: "/charts",
    component: Charts,
    authorize: [
      profiles.participant,
      profiles.medicalMonitor,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    redirectNonStudyEnrolled: "/accessdenied",
    study: studiesIds.lcfaod402,
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: true,
  },
];

export default {
  routesArray: routesArray,
  onRouteChange: () => {},
  onProtectedRouteChange: (userType) => {
    //On each protected route change, if current user is a participant we need to check if all the user-lifecycle steps are complete
    if (userType === profiles.participant) {
      axios
        .get("/api/survey/participant/nextstep")
        .then(({ data }) => {
          if (Object.entries(data).length) {
            sendNotification(
              "You have pending account actions that block your activities.",
              ToastType.WARNING
            );
            history.push("/next-steps");
          }
        })
        .catch((e) => {
          history.push("/home");
          sendNotification(e?.response?.data, ToastType.ERROR);
        });
    }
  },
};
